import React from "react";
import {useTranslation} from "react-i18next";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";

import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {SubCompanyPropTypes} from "./FilterComponentPropTypes";
import {SelectField} from "./FilterComponentStyles";

const PoolCourierFilter = ({
    value,
    onChange,
    poolId,
    disabled = true,
    mode = undefined,
    allowClear = false
}) => {
    const {t} = useTranslation();
    const stores = useStore();

    const [loading, poolCouriersData, _, __] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolShiftStore.getPoolCouriers.bind(null, {
            poolId
        }),
        dependencies: [poolId],
        initialCall: Boolean(poolId),
        condition: poolId
    });
    return (
        <React.Fragment>
            <h5>{t("fields.courier", {ns: "common"})}</h5>
            <SelectField
                loading={loading}
                data-testid="subCompanySelect"
                value={value}
                onChange={onChange}
                disabled={disabled && (!poolId || loading)}
                mode={mode}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                allowClear={allowClear}
            >
                {poolCouriersData?.data &&
                    poolCouriersData?.data?.length > 0 &&
                    arrayAlphabeticalSort([...poolCouriersData?.data], "fullname").map(
                        poolCourier => (
                            <SelectField.Option
                                key={poolCourier._id}
                                value={poolCourier._id}
                                data-testid="poolCourierSelect_option"
                            >
                                {poolCourier.fullname}
                            </SelectField.Option>
                        )
                    )}
            </SelectField>
        </React.Fragment>
    );
};

export default PoolCourierFilter;
